<script lang="ts">
/* eslint-disable*/
export default {
    name: "TradeInWidget",
    inject: ["appInstance", "widget"],
};
/* eslint-disable*/
</script>

<script setup lang="ts">
import { computed, onMounted } from "vue";

import Carousel from "@/components/carousel/carousel.vue";
import Container from "@/components/container/container.vue";
import ImageFullScreen from "@/components/imageFullScreen/imageFullScreen.vue";
import { ChooseDelivery } from "@/components/modalSteps/chooseDelivery";
import ChooseDevice from "@/components/modalSteps/chooseDevice/chooseDevice.vue";
import ChooseDeviceToBuy from "@/components/modalSteps/ChooseDeviceToBuy/ChooseDeviceToBuy.vue";
import { ChooseRangeDiscount } from "@/components/modalSteps/chooseRangeDiscount";
import ChooseSigningType from "@/components/modalSteps/chooseSigningType/chooseSigningType.vue";
import ConfirmBelowPrice from "@/components/modalSteps/confirmBelowPrice/confirmBelowPrice.vue";
import { ConfirmSigned } from "@/components/modalSteps/confirmSigned";
import {
    CreditCartPreAuthorization,
    CreditCartPreAuthorizationFailed,
    CreditCartPreAuthorizationPayment,
    CreditCartPreAuthorizationSuccess,
} from "@/components/modalSteps/creditCartPreAuthorization";
import DownloadPhotos from "@/components/modalSteps/downloadPhotos/downloadPhotos.vue"; // [V-SHOW] что бы не сбрасывались данные нативного input.file при размонтировании компонента из DOM
import EnterImei from "@/components/modalSteps/enterImei/enterImei.vue";
import EvaluationResult from "@/components/modalSteps/evaluationResult/evaluationResult.vue";
import HowYouRateDevice from "@/components/modalSteps/howYouRateDevice/howYouRateDevice.vue";
import InitWidgetLoader from "@/components/modalSteps/initWidgetLoader/initWidgetLoader.vue";
import OperatorExecuting from "@/components/modalSteps/operatorExecuting/operatorExecuting.vue";
import {
    PersonAuthentication,
    PersonAuthenticationFailed,
    PersonAuthenticationSuccess,
} from "@/components/modalSteps/personAuthentication";
import DocumentsUpload from "@/components/modalSteps/personAuthentication/documentsUpload.vue";
import PreliminaryPrice from "@/components/modalSteps/PreliminaryPrice/PreliminaryPrice.vue";
import SendSmsContract from "@/components/modalSteps/sendSmsContract/sendSmsContract.vue";
import SigningWithoutSms from "@/components/modalSteps/signingWithoutSms/signingWithoutSms.vue";
import SuccessfulEvaluation from "@/components/modalSteps/successfulEvaluation/successfulEvaluation.vue";
import SuccessfulEvaluationFailed from "@/components/modalSteps/successfulEvaluation/successfulEvaluationFailed.vue";
import "@/scss/global.scss";
import ThanksForOrder from "@/components/modalSteps/thanksForOrder/thanksForOrder.vue";
import { ThanksYou } from "@/components/modalSteps/thanksYou";
import { VoucherSent } from "@/components/modalSteps/voucherSent";
import VisualEvaluation from "@/components/VisualEvaluation/VisualEvaluation.vue";
import { BugTrackerSection, useBugTracker } from "@/helpers/bugTracker";
import { suck, warn } from "@/helpers/consoleColors";
import it4Login from "@/hooks/requests/it4Login/it4Login";
import { useTIWStore } from "@/stores/tiw/tiw";

const TIWStore = useTIWStore();

onMounted(async () => {
    console.log("%c[TIWidget] -> APP is Mounted", suck);
    console.log("%c[TIWidget] -> press to any [Trade-In with Good] button", warn);
    TIWStore.initTradeInWithGood();
    TIWStore.INJECTED_TIW.current_api.onLoad();

    if (window) {
        const data = window.localStorage.getItem("oplData");
        const oplData = JSON.parse(data);
        if (oplData) {
            if (oplData?.token) TIWStore.AUTH_TOKEN = oplData.token;
            if (oplData?.channel) TIWStore.CHANNEL = oplData.channel;
        }
    }

    try {
        const loginData = await it4Login({
            authorizationToken: TIWStore.AUTH_TOKEN,
            channel: TIWStore.CHANNEL,
        });
        if (loginData.success) {
            TIWStore.SESSION_TOKEN = loginData.session;
        }
    } catch (e) {
        useBugTracker("getting login data", BugTrackerSection.ERROR, {
            message: e.message,
        });
        console.log(e);
    }
});

const containerSectionClassList = computed<string[]>(() => {
    return ["tiw__modal", "tiw__step"];
});
</script>

<template>
    <Container>
        <section :class="containerSectionClassList">
            <ConfirmBelowPrice v-if="TIWStore.isCurrentStep('confirmBelowPrice')" />
            <SuccessfulEvaluationFailed
                v-if="TIWStore.isCurrentStep('successfulEvaluationFailed')"
            />
            <DocumentsUpload v-if="TIWStore.isCurrentStep('documentsUpload')" />
            <InitWidgetLoader v-if="TIWStore.IS_INIT_WIDGET_LOADING" />
            <ChooseDevice v-if="TIWStore.isCurrentStep('chooseDevice')" />
            <ChooseDeviceToBuy v-if="TIWStore.isCurrentStep('chooseDeviceToBuy')" />
            <ChooseDelivery v-if="TIWStore.isCurrentStep('chooseDelivery')" />
            <ChooseRangeDiscount v-if="TIWStore.isCurrentStep('chooseRangeDiscount')" />
            <CreditCartPreAuthorization
                v-if="TIWStore.isCurrentStep('creditCartPreAuthorization')"
            />
            <PersonAuthentication v-if="TIWStore.isCurrentStep('personAuthentication')" />
            <CreditCartPreAuthorizationFailed
                v-if="TIWStore.isCurrentStep('creditCartPreAuthorizationFailed')"
            />
            <CreditCartPreAuthorizationSuccess
                v-if="TIWStore.isCurrentStep('creditCartPreAuthorizationSuccess')"
            />
            <CreditCartPreAuthorizationPayment
                v-if="TIWStore.isCurrentStep('creditCartPreAuthorizationPayment')"
            />
            <PersonAuthenticationFailed
                v-if="TIWStore.isCurrentStep('personAuthenticationFailed')"
            />
            <PersonAuthenticationSuccess
                v-if="TIWStore.isCurrentStep('personAuthenticationSuccess')"
            />
            <ConfirmSigned v-if="TIWStore.isCurrentStep('confirmSigned')" />
            <VoucherSent v-if="TIWStore.isCurrentStep('voucherSent')" />
            <ThanksYou v-if="TIWStore.isCurrentStep('thanksYou')" />
            <ThanksForOrder v-if="TIWStore.isCurrentStep('thanksForOrder')" />
            <SendSmsContract v-if="TIWStore.isCurrentStep('sendSmsContract')" />
            <HowYouRateDevice v-if="TIWStore.isCurrentStep('howYouRateDevice')" />
            <VisualEvaluation v-if="TIWStore.isCurrentStep('visualEvaluation')" />
            <PreliminaryPrice v-if="TIWStore.isCurrentStep('preliminaryPrice')" />
            <EnterImei v-if="TIWStore.isCurrentStep('enterImei')" />
            <DownloadPhotos v-show="TIWStore.isCurrentStep('downloadPhotos')" />
            <OperatorExecuting v-if="TIWStore.isCurrentStep('operatorExecuting')" />
            <SuccessfulEvaluation v-if="TIWStore.isCurrentStep('successfulEvaluation')" />
            <EvaluationResult v-if="TIWStore.isCurrentStep('evaluationResult')" />
            <SigningWithoutSms v-if="TIWStore.isCurrentStep('signingWithoutSms')" />
            <ChooseSigningType v-if="TIWStore.isCurrentStep('chooseSigningType')" />
        </section>

        <template #after-wrapper>
            <ImageFullScreen />
            <Carousel />
        </template>
    </Container>
</template>
